import { render, staticRenderFns } from "./6.vue?vue&type=template&id=729fdbed&scoped=true&"
var script = {}
import style0 from "./6.vue?vue&type=style&index=0&id=729fdbed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fdbed",
  null
  
)

export default component.exports